import { boot } from 'quasar/wrappers'
import { createAuth0 } from '@auth0/auth0-vue';

export default boot(({ app }) => {

  app.use(
    createAuth0({
      domain: process.env.AUTH0_DOMAIN,
      client_id: process.env.AUTH0_CLIENT_ID,
      redirect_uri: `${ window.location.origin }/callback`,
      audience: process.env.AUTH0_AUDIENCE
    })
  );
})
